import React, { Component } from 'react';
import "./msi.css";
import Map from './MapContainer';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import UEFAChampionsLeagueAssistsChart from "./Mis";
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
import moment from 'moment';
import Storage from "../../services/local-store";
import MapContainer from './MapContainer';
import DateRange from '../../components/FormComponent/DateRange';
import { Select, Spin, Empty ,  Space } from 'antd';
import proj4 from "proj4";
import mapDataIE from "@highcharts/map-collection/countries/in/in-all.geo.json";
import HighchartsMap from "highcharts/modules/map";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'antd'; // Import the Ant Design CSS
import { CaretDownOutlined } from '@ant-design/icons';


HighchartsMap(Highcharts);
class MsiReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            barChartOPtions: {},
            semiCircleOptions: {},
            areaSplineOptions: {},
            dateFrom: moment().format("YYYY-MM-DD"),
            dateTo: moment().format("YYYY-MM-DD"),
            avgProcedureTime: 0,
            avgWaitingTime: 0,
            averagePatientsPerHour: 0,
            totalActiveQueue: 0,
            queueAssginDoctors: 0,
            selectedOptions: [],
            mappedUnits: [],
            allUnits: [],
            active_unit: [],
            

        }
    }
    componentDidMount() {
        let current_Unit = Storage.get("current_Unit");
        let current_Unit_Details = current_Unit && JSON.parse(current_Unit);

        let allTokens = JSON.parse(Storage.get("all_tokens"));
        let storeToken = current_Unit_Details && current_Unit_Details.token ? current_Unit_Details.token :
            allTokens && allTokens[0] && allTokens[0].token
                ? allTokens[0].token
                : null;


        let userData = JSON.parse(Storage.get("user_data"));

        let unitid = current_Unit_Details && current_Unit_Details.unit_id ? current_Unit_Details.unit_id :
            userData && userData.unitid ? userData.unitid : null;
        userData.unitid = unitid

        let unitname = current_Unit_Details && current_Unit_Details.unit_name ? current_Unit_Details.unit_name :
            allTokens && allTokens[0] && allTokens[0].unit_name
                ? allTokens[0].unit_name
                : null;

        let displayname = current_Unit_Details && current_Unit_Details.display_name ? current_Unit_Details.display_name :
            allTokens && allTokens[0] && allTokens[0].display_name
                ? allTokens[0].display_name
                : null;

        this.setState({ currentUnitPlace: displayname, "active_unit": userData ? [userData['unitid']] : null })

        let obj = {
            unitid: unitid, unitname: unitname, displayname: displayname, token: storeToken
        }
        this.setState({ currentUnitDetails: obj }, () => {
            // this.fetchData();
        })
        let all_tokens = Storage.get("all_tokens");
        let all_tokens_details = all_tokens && JSON.parse(all_tokens);
        let newData = [];
        if (all_tokens_details && all_tokens_details.length !== 0) {
            all_tokens_details.map((rdata, rKey) => {
                newData.push({
                    'name': rdata['display_name'],
                    'id': rdata['unit_id'],
                    // 'value': rdata['unit_name'],
                })
            })
        }
      
        this.setState((state) => ({ 'mappedUnits': newData }));
        // this.fetchData();
    }
    handleChangeDate = (dateString, date) => {
        this.setState(
            {
                dateFrom: dateString.value[0],
                dateTo: dateString.value[1],
            },
            () => {
                // Call fetchData with the updated obj
                this.fetchData();
            }
        );
        // this.fetchData();
        // }
    };

    fetchData() {
        const { getQueueStatsUnits } = networkList;
        const { dateTo, dateFrom, currentUnitDetails, barChartOPtions, active_unit } = this.state;
        let userData = JSON.parse(Storage.get("user_data"));
        let allunits_ids = active_unit.length > 0 ? active_unit : userData ? [userData['unitid']] : null
        const obj = {
            // "unit_ids": ["7", "21"],
            unit_ids: active_unit.length > 0 ? active_unit : userData ? [userData['unitid']] : null,

            // to_date: "2023-07-03",
            to_date: dateTo ? moment(dateTo).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            from_date: dateFrom ? moment(dateFrom).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            // from_date: "2023-07-03"
        };
        this.setState({ isLoading: true });


        postService('getQueueStatsMulityUnits', "POST", { data: obj }).then((res) => {
            if (res) {
                this.setState({ isLoading: false });
                if (res.status) {
                    // let { opd_consulting } = res["data"];
                    let opd_consulting = res['data']
                    let unitsall = allunits_ids;
                    let avgProcedureTime = 0
                    let avgWaitingTime = 0
                    let averagePatientsPerHour = 0
                    let totalActiveQueue = 0
                    let queueAssginDoctors = 0
                    let categories = [];
                    let plannedVisits = []
                    let unplannedVisit = []
                    let totalSkips = []
                    let total_patients = 0;
                    let serviced = 0
                    let waitingTimes = []
                    let procedureTimes = []
                    let allUnits = []

                    // debugger

                    if (Object.keys(opd_consulting).length !== 0) {
                        for (let i = 0; i < unitsall.length; i++) {
                            let obj = {
                            }
                            avgProcedureTime += opd_consulting[unitsall[i]].avg_procedure_time || 0;
                            avgWaitingTime += opd_consulting[unitsall[i]].avg_waiting_time;
                            // averagePatientsPerHour += opd_consulting[unitsall[i]].avg_patients_per_hour;
                            averagePatientsPerHour += opd_consulting[unitsall[i]].avg_patients_per_hour || 0;
                            totalActiveQueue += opd_consulting[unitsall[i]].totalActiveQueue;
                            queueAssginDoctors += opd_consulting[unitsall[i]].queueAssginDoctors;
                            categories.push(opd_consulting[unitsall[i]].unitname)
                            plannedVisits.push(opd_consulting[unitsall[i]].planned_visits)
                            unplannedVisit.push(opd_consulting[unitsall[i]].unplanned_visits)
                            totalSkips.push(opd_consulting[unitsall[i]].total_skips)
                            waitingTimes.push(opd_consulting[unitsall[i]].avg_waiting_time)
                            procedureTimes.push(opd_consulting[unitsall[i]].avg_procedure_time)
                            total_patients += opd_consulting[unitsall[i]].total_patients
                            serviced += opd_consulting[unitsall[i]].serviced
                            obj['name'] = opd_consulting[unitsall[i]].unitname;
                            obj['lat'] = parseFloat(opd_consulting[unitsall[i]].location.lat);
                            obj['lon'] = parseFloat(opd_consulting[unitsall[i]].location.lon);
                            obj['total_patients'] = opd_consulting[unitsall[i]].total_patients;
                            obj['z'] = opd_consulting[unitsall[i]].total_patients;
                            allUnits.push(obj);
                        }
                        averagePatientsPerHour = averagePatientsPerHour.toFixed(2);
                    }

                  
                    var selectElement = document.getElementById('unitSelect');

                    let barchart = {
                        chart: {
                            type: 'column',
                            height: "200px",
                        },
                        title: {
                            text: ' ',
                            enabled: true,
                            align: 'left',
                        },
                        legend: {
                            align: 'left', // Align the legend to the center
                            verticalAlign: 'top', // Place the legend at the top
                            layout: 'horizontal', // Display the legend horizontally
                        },
                        xAxis: {
                            categories: categories,
                            labels: {
                                align: "center",
                                style: {
                                    fontWeight: "bold",
                                    fontFamily: "Avenir",
                                    color: "black"
                                }
                            }
                        },
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Visits & Skips',
                                style: {
                                    fontWeight: "bold",
                                    fontFamily: "Avenir !important"
                                }
                            },
                            tickPositions: [0, 25, 50, 75, 100],
                            labels: {
                                formatter: function () {
                                    return this.value + '%'; // Add '%' to the labels
                                },
                            },
                        },

                        tooltip: {
                            pointFormat:
                                '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                            shared: true,
                        },
                        plotOptions: {
                            column: {
                                stacking: 'percent',
                                dataLabels: {
                                    enabled: true, // Set to true to enable data labels
                                    format: '{point.y}', // Display the data value
                                    style: {
                                        fontWeight: 'bold', // Adjust the style as needed
                                        color: 'white',
                                    },
                                    inside: true, // Display data labels inside the bars
                                },
                                grouping: false,
                                // pointPlacement: 'on',
                                pointWidth: 60,
                            },

                        },
                        credits: {
                            enabled: false
                        },
                        series: [
                            {
                                name: 'Sum of Total Skips',
                                data: totalSkips,
                                color: "#FBAB9C",
                            },
                            {
                                name: 'Sum of Unplanned Visits',
                                data: unplannedVisit,
                                color: '#C5E0B4',
                            },
                            {

                                name: 'Sum of Planned Visits',
                                data: plannedVisits,
                                color: '#548235',
                            },
                        ],

                    };
                    let semicircle = {
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: 0,
                            plotShadow: false,
                            height: "200px",
                            spacingTop: 0,
                            spacingBottom: 0,
                            spacingLeft: 0,
                            spacingRight: 0,
                            margin: [0, 0, 0, 0],
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: 0,
                            align: 'left',
                            verticalAlign: '',
                            y: 240,
                            x: 70
                        },
                        subtitle: {
                            text: total_patients, // Right side title
                            align: 'right', // Align the right title to the right
                            verticalAlign: '',
                            y: 240, // Adjust the vertical position of the right title as needed
                            x: -70,
                            style: {
                                fontSize: '16px', // Customize the right title font size

                            },
                        },
                        tooltip: {
                            formatter: function () {
                                return `<b>${this.point.name}</b>: ${this.y}`;
                            },
                        },
                        accessibility: {
                            point: {
                                valueSuffix: '%'
                            }
                        },
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    enabled: true,
                                    distance: -35,
                                    useHtml: true,
                                    style: {
                                        fontWeight: 'bold',
                                        color: 'white',
                                        textAlign: "center"
                                    },
                                    format: '{point.y}<br/> <p className="text-center">{point.name}</p>',
                                },
                                startAngle: -90,
                                endAngle: 90,
                                center: ['50%', '85%'],
                                size: '170%'
                            }
                        },
                        series: [
                            {
                                type: 'pie',
                                innerSize: '50%',
                                data: [
                                    {
                                        
                                        name: 'Served', // Name for the first data point
                                        // Data value
                                        y: serviced,
                                        //orderLabel: 'Served: ' + (serviced),
                                        color: '#548235',
                                    },
                                    {
                                     
                                        name: 'Not Served', // Name for the second data point
                                        // Data value
                                        y: total_patients - serviced,
                                       // orderLabel: 'Not Served: ' + (total_patients - serviced),
                                        color: '#FBAB9C',
                                    },
                                ],
                            },
                        ],
                    };
                    // i a setting heights to avoid too much scrolling, you can modify the later according to your need
                    // change colors also for this graph according to your project
                    // let areaspline = {
                    //     chart: {
                    //         type: 'areaspline',
                    //         height: "200px",
                    //     },
                    //     title: {
                    //         text: '',
                    //     },
                    //     legend: {
                    //         align: 'left', // Align the legend to the center
                    //         verticalAlign: 'top', // Place the legend at the top
                    //         layout: 'horizontal', // Display the legend horizontally
                    //     },
                    //     xAxis: {
                    //         categories: categories,
                    //         labels: {
                    //             align: "center",
                    //             style: {
                    //                 fontWeight: "bold",
                    //                 fontFamily: "Avenir",
                    //                 color: "black" // Set the font color to black
                    //             }
                    //         }
                    //     },
                    //     yAxis: {
                    //         min: 0,
                    //         max: 100,
                    //         title: {
                    //             text: 'Sum of Average',
                    //             style: {
                    //                 fontWeight: "bold",
                    //                 fontFamily: "Avenir"
                    //             }

                    //         },
                    //         tickPositions: [0, 25, 50, 75, 100],
                    //         labels: {
                    //             formatter: function () {
                    //                 return this.value + '%'; // Add '%' to the labels
                    //             },
                    //         },
                    //     },
                    //     credits: {
                    //         enabled: false
                    //     },
                    //     series: [
                    //         {
                    //             name: 'Sum of Average Procedure Time(Min)',
                    //             data: procedureTimes,
                    //             color: {
                    //                 linearGradient: {
                    //                     x1: 1,
                    //                     y1: 0,
                    //                     x2: 0,
                    //                     y2: 0,
                    //                 },
                    //                 stops: [
                    //                     [0, Highcharts.Color("#548235").setOpacity(1).get("rgba")],
                    //                     [1, Highcharts.Color("#548235").setOpacity(1).get("rgba")],
                    //                 ],
                    //             },
                    //             fillColor: {
                    //                 linearGradient: {
                    //                     x1: 0,
                    //                     y1: 0,
                    //                     x2: 0,
                    //                     y2: 1,
                    //                 },
                    //                 stops: [
                    //                     [0, Highcharts.Color("#548235").setOpacity(0.1).get("rgba")],
                    //                     [1, Highcharts.Color("#548235").setOpacity(0).get("rgba")],
                    //                 ],
                    //             },
                    //         },
                    //         {
                    //             name: 'Sum of Avg Waiting Time(Min)',
                    //             data: waitingTimes,
                    //             color: {
                    //                 linearGradient: {
                    //                     x1: 1,
                    //                     y1: 0,
                    //                     x2: 0,
                    //                     y2: 0,
                    //                 },
                    //                 stops: [
                    //                     [0, Highcharts.Color("#FBAB9C").setOpacity(1).get("rgba")],
                    //                     [1, Highcharts.Color("#FBAB9C").setOpacity(1).get("rgba")],
                    //                 ],
                    //             },
                    //             fillColor: {
                    //                 linearGradient: {
                    //                     x1: 0,
                    //                     y1: 0,
                    //                     x2: 0,
                    //                     y2: 1,
                    //                 },
                    //                 stops: [
                    //                     [0, Highcharts.Color("#FBAB9C").setOpacity(0.1).get("rgba")],
                    //                     [1, Highcharts.Color("#FBAB9C").setOpacity(0).get("rgba")],
                    //                 ],
                    //             },
                    //         },
                    //     ],
                    // }
                    let areaspline = {
                        chart: {
                            type: 'areaspline',
                            height: "240px",
                        },
                        title: {
                            text: '',
                        },
                        legend: {
                            align: 'left',
                            verticalAlign: 'top',
                            layout: 'horizontal',
                        },
                        xAxis: {
                            categories: categories,
                            labels: {
                                align: "center",
                                style: {
                                    fontWeight: "bold",
                                    fontFamily: "Avenir",
                                    color: "black"
                                }
                            }
                        },
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Sum of Average',
                                style: {
                                    fontWeight: "bold",
                                    fontFamily: "Avenir"
                                }
                            },
                            tickPositions: [0, 25, 50, 75, 100],
                            labels: {
                                formatter: function () {
                                    return this.value + '%';
                                },
                            },
                        },
                        credits: {
                            enabled: false
                        },
                        series: [
                            {
                                name: 'Sum of Average Procedure Time(Min)',
                                data: procedureTimes,
                                color: "#275D38",  // Darker green color
                                fillColor: "rgba(39, 93, 56, 0.1)",  // Lighter green shade
                            },
                            {
                                name: 'Sum of Avg Waiting Time(Min)',
                                data: waitingTimes,
                                color: "#C1452D",  // Darker red color
                                fillColor: "rgba(193, 69, 45, 0.1)",  // Lighter red shade
                            },
                        ],
                    };
                    
                    const options = {
                        chart: {
                            map: mapDataIE,
                            proj4,
                            height: "240px",
                        },
                        title: {
                            text: ' ',
                            enabled: true,
                        },
                        series: [
                            { 
                                
                                type: "map",
                                mapData: mapDataIE,
                                borderColor: "#a0a0a0",
                               // nullColor: "white",
                                showInLegend: false,

                            },
                            {
                                type: "mapbubble",
                                name: "Units",
                                data: allUnits,
                                color: "#548235",
                                minSize: 5,
                                maxSize: 10,
                                fillOpacity:0.7,
                                point: {
                                    events: {
                                        click: this.handlePointClick, // Attach click event handler
                                    },
                                },
                            },
                        ],
                        plotOptions: {
                            series: {
                                cursor: "pointer", // Enable cursor pointer on map points
                                point: {
                                    events: {
                                        click: this.handlePointClick, // Attach click event handler
                                    },
                                },
                                clipBubbles:true,
                                // dataLabels:{
                                //     enabled:true,
                                //     format:"{point.name}",
                                //     formatter: function(){
                                //         return this.point.name;
                                //     }

                                // }
                                
                            },
                        },
                        credits: {
                            enabled: false
                        },
                        tooltip: {
                            shared: true,
                            backgroundColor: "white",
                            outside: true,
                            headerFormat: "sdf",
                            formatter: function (tooltip) {
                                var str = "";
                                // console.log(series[0].data.indexOf(this.y));
                                const headerIndex = allUnits.indexOf(this.y);
                             
                                if (this.point) {
                                    let point = this.point
                                    str +=
                                        '<span style="color:' +
                                        point.color +
                                        '">\u25CF</span> ' + '<span>Total Patients</span>' + '<span> : </span>' + 
                                        point.total_patients +
                                        "</b><br/>"+
                                        '<span style="color:' +
                                        point.color +
                                        '">\u25CF</span> ' + '<span>Unit Name</span>' + '<span> : </span>' + 
                                        point.name +
                                        "</b><br/>";
                                }

                                return `<table><tr><th colspan="2"><b>
                       
                          </b></th></tr></table> <br/>${str}`;
                            },
                        },
                        mapNavigation: {
                            enabled: true, // Enable map navigation (zooming, panning)
                        },
                       
                    };


                   
                    this.setState({ avgProcedureTime: avgProcedureTime, avgWaitingTime: avgWaitingTime, averagePatientsPerHour: averagePatientsPerHour, totalActiveQueue: totalActiveQueue, queueAssginDoctors: queueAssginDoctors, barChartOPtions: barchart, semiCircleOptions: semicircle, areaSplineOptions: areaspline, allUnits: allUnits, options: options })


                }
            }
        });
    }


   
   
   
    
    
    
    
    
    handleChange = (value) => {
        this.setState(
            {
                active_unit: value
            },
            () => {
                // Call fetchData with the updated obj
                this.fetchData();
            }
        );


    };
    customDropdown = (menu) => (
        <div>
          {menu}
          <div style={{ textAlign: 'right', padding: '4px' }}>
            {/* <Icon type="caret-down" /> */}
          

<CaretDownOutlined />;
          </div>
        </div>
      );

    render() {
        const Option = Select.Option;
        const { fetching } = this.state;
        let { barChartOPtions, areaSplineOptions, semiCircleOptions, locations, avgProcedureTime, avgWaitingTime, averagePatientsPerHour, totalActiveQueue, queueAssginDoctors, mappedUnits, allUnits, options, active_unit } = this.state;
        const children = [];
        mappedUnits.length > 0 && mappedUnits.map((data, key) => {
            if (data.id !== null) {
                children.push(
                    <Option key={key} value={data.id}>
                        {data.name ? data.name : data.value}
                    </Option>
                );
            }
        });
       
        return (

            <div className="container-fluid ">
                <div className='row mb-3'> 
                <div className='col-12 mb-4 '>
                  {/* <h6 style={{fontWeight:'700'}}>QMS REAL TIME REPORT</h6> */}
                  </div >
                  </div>
                <div className='row row-data mt-4 mb-2' >
                <div className='col-1' style={{paddingLeft:'0px',paddingRight:'0px'}}>
                </div>
                    <div className='col-7' style={{paddingLeft:'0px',marginLeft:'-41px'}}>
                        <div className='row'>
                            <div className="col-3 custom-padding-right"style={{paddingLeft:'0px',paddingRight:'0px'}}>
                                <div className="card   graph-card card-info" style={{ height: "74px" }}>
                                    <div className='card-body' style={{ display: "flex", justifyContent: "center", alignItems: "center",padding:'0.25rem' }}>
                                        <div style={{ backgroundColor: "#DFCCFB", padding: "1px", marginRight: "5px", borderRadius: "50%",marginBottom: '1px' }}>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 640 512" style={{ fill: "#5B0888" }}> 
                                        <path d="M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z" />
                                    </svg> */}
                                            <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 576 512" style={{ fill: "#5B0888" }} ><path d="M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z" /></svg>
                                        </div>
                                        <div>
                                            <p className='font-weight-bold' style={{ marginBottom: "2px" }}>{averagePatientsPerHour}</p>
                                            <p style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.6)" }}>Avg . Patients Per Hour</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 custom-padding-right" style={{paddingRight:'0px'}}>
                                <div className="card   graph-card card-info" style={{  height: "74px" }}>
                                    <div className='card-body' style={{ display: "flex", justifyContent: "center", alignItems: "center",padding:'0.25rem' }}>
                                        <div style={{ backgroundColor: "#EFB495", padding: "1px", marginRight: "5px", borderRadius: "50%",marginBottom: '1px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 640 512" style={{ fill: "#CD5C08" }}><path d="M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z" /></svg>
                                        </div>
                                        <div>
                                            <p className="font-weight-bold" style={{ marginBottom: "2px" }}>{avgProcedureTime}{" "}{`min`}</p>
                                            <p style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.6)" }}>Avg . Procedure Time</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 custom-padding-right" style={{paddingRight:'0px'}}>
                                <div className="card   graph-card card-info" style={{  height: "74px" }}>
                                    <div className='card-body' style={{ display: "flex", justifyContent: "center", alignItems: "center",padding:'0.25rem' }}>
                                        <div style={{ backgroundColor: "#F9F3CC", padding: "1px", marginRight: "5px", borderRadius: "50%",marginBottom: '1px' }}>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 640 512"  style={{ fill: "#E19898" }} ><path d="M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"/></svg> */}
                                            <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 512 512" style={{ fill: "#FFCD4B" }}><path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" /></svg>
                                        </div>
                                        <div>
                                            <p className="font-weight-bold" style={{ marginBottom: "2px" }}>{avgWaitingTime}{" "}{`min`}</p>
                                            <p style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.6)" }}>Avg . Waiting Time</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 custom-padding-right" >
                                <div className="card   graph-card card-info" style={{  height: "74px" }}>
                                    <div className='card-body' style={{ display: "flex", justifyContent: "center", alignItems: "center",padding:'0.25rem' }}>
                                        <div style={{ backgroundColor: "#CDFAD5", padding: "1px", marginRight: "5px", borderRadius: "50%" ,marginBottom: '1px'}}>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 640 512"  style={{ fill: "#279EFF" }}><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" /></svg> */}
                                            <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 448 512" style={{ fill: "#17A858" }}><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" /></svg>
                                        </div>
                                        <div>
                                            <p className="font-weight-bold" style={{ marginBottom: "2px" }}>{queueAssginDoctors} / {totalActiveQueue}</p>
                                            <p style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.6)" }}>Active Doctors</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-4 ' style={{paddingRight:'0px',paddingLeft:'0px'}}>
                        <div className='row'>
                            <div className="col-12" style={{paddingRight:'0px'}}>
                                <Select
                                    mode="multiple"
                                    className='unit_chats'
                                    allowClear
                                    bordered
                                    dropdownRender={this.customDropdown.bind(this)}
                                    maxTagCount={1}
                                    style={{ width: '94%',height:'20%' }}
                                    placeholder="Please select"
                                    defaultValue={active_unit ? active_unit : null}
                                    value={active_unit ? active_unit : null}
                                    onChange={this.handleChange.bind(this)}
                                    // className="custom-select"
                                    

                                >{children}</Select>
                            {/* </div>  
                            <div className="col-12">   */}
                            <div className="mt-3"  style={{marginRight:'28px'}}>
                                <DateRange
                                    dateFrom={this.state.dateFrom}
                                    dateTo={this.state.dateTo}
                                    selectdata={{ name: 'dashboardFilters' }} // Customize as needed
                                    // onselectChanges={this.handleChange.bind(this)}
                                    onselectChanges={this.handleChangeDate.bind(this)}
                                    className = "date-range"
                                    style={{ width: '96%',height:'20%' }}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row row-data  mt-1'>
                <div className='col-1' style={{paddingLeft:'0px',paddingRight:'0px'}}>
                <h6 className='qms_real_tiem' style={{fontWeight:'700'}}> <svg xmlns="http://www.w3.org/2000/svg" height="1em" width="1em" viewBox="0 0 512 512" style={{ transform: 'rotate(90deg)' , position: 'relative', bottom: '4px', right:"4px" }}><path d="M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"/></svg> QMS REAL TIME REPORT </h6> 
                </div>
                    <div className='col-7 ' style={{paddingLeft:'0px',marginLeft:'-57px',paddingRight:'0px'}}>
                        <div className='card  graph-card'>
                            <div className='card-body' style={{padding:'0px'}}>
                                <p className='font-weight-bold my-2 ml-4'>Planned / Un-Planned / Skipped Visits</p>
                                <UEFAChampionsLeagueAssistsChart options={barChartOPtions} />
                            </div>
                        </div>
                    </div>
                    <div className='col-4' style={{paddingRight:'0px'}}>
                        <div className='card  graph-card'>
                            <div className='card-body' style={{padding:'0px'}}>
                                <p className='font-weight-bold my-2 ml-4'>Served Visits</p>
                                <UEFAChampionsLeagueAssistsChart options={semiCircleOptions} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row row-data mt-1'>
                <div className='col-1'style={{paddingLeft:'0px',paddingRight:'0px'}}>
                </div>
                    <div className='col-4'  style={{paddingLeft:'0px',marginLeft:'-57px',paddingRight:'0px'}}>
                        <div className='card my-2 graph-card'>
                            <div className='card-body'style={{padding:'0px'}}>
                                <p className='font-weight-bold my-2 ml-4'>Sum of Total Patients by Unit</p>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={options}
                                    constructorType={"mapChart"}
                                />
                                {/* <MapContainer onClick={e=>console.log(e.name)} {...allUnits}/> */}
                            </div>
                        </div>
                    </div>
                    <div className='col-7' style={{paddingRight:'0px'}}>
                        <div className='card my-2 graph-card'>
                            <div className='card-body'style={{padding:'0px'}}>
                                <p className='font-weight-bold my-2 ml-4'>Avg Procedure Time vs Avg Waiting Time Trends </p>
                                <UEFAChampionsLeagueAssistsChart options={areaSplineOptions} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

    }

}
export default MsiReports;
